import { gql } from "@apollo/client";

export const GET_AUTHOR_READERS = gql`
  query allCommunityBooks(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: PostFilter
  ) {
    books: allCommunityBooks(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      author {
        id
        name
        image
      }
      categories {
        id
        name
        buy_text
      }
      chapters
      description_short
      themes
      disabled
      features
      glossary
      glossary_less
      guide_url
      has_aboutstory
      has_cultural
      has_glossary
      has_introduction
      has_prereading
      id
      image_ver
      images {
        cover
        thumb
        poster
        __typename
      }
      is_new
      keys_url
      language {
        id
        name
        active
        __typename
      }
      level {
        id
        name
        __typename
      }
      level_id
      nav_colors {
        background
        color
        __typename
      }
      print_url
      rank
      rating
      rating_students
      rating_teachers
      release_date
      score
      title
      total_ratings
      total_words
      tense
      url
      user_chapter
      unique_words
      video_url
      vocab_url
      __typename
      id
    }
    total: _allCommunityBooksMeta(
      page: $page
      perPage: $perPage
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;
